import { Button, Col, Row, Space } from 'antd';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from '../../store/app';
import { setTranslationLanguage } from '../../store/CommonSlice';

const DashboardTranslateButtons = () => {
    const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);
    const dispatch: AppDispatch = useDispatch();

    const setLanguage = (lang: string) => {
        // alert(lang);
        dispatch(setTranslationLanguage(lang));
    }

    return <>
        <Space wrap={true} align='center' className='dashboard-translate-buttons' >
            <Button className={'common_button green_border_common_btn translate-custom notranslate '+(translationLanguage=='en' ?'common_fill_button':'' )} onClick={()=>setLanguage('en')}>EN</Button>
            <Button className={'common_button green_border_common_btn translate-custom notranslate ' +(translationLanguage=='es' ?'common_fill_button':'' )} onClick={()=>setLanguage('es')}>ES</Button>
        </Space>

    </>
};
export default DashboardTranslateButtons;